/* tslint:disable */
/* auto-generated angular directive proxies */
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, EventEmitter, NgZone } from '@angular/core';

import { ProxyCmp, proxyOutputs } from './angular-component-lib/utils';

import { Components } from '@mri/ask-agora-insights';


@ProxyCmp({
  inputs: ['apiHost', 'assetSource', 'clientId', 'isActivated', 'showIcon', 'widgetOffset']
})
@Component({
  selector: 'ask-ai',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['apiHost', 'assetSource', 'clientId', 'isActivated', 'showIcon', 'widgetOffset'],
})
export class AskAi {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['popupClose']);
  }
}


export declare interface AskAi extends Components.AskAi {

  popupClose: EventEmitter<CustomEvent<void>>;
}


@ProxyCmp({
  inputs: ['completion', 'formattedText']
})
@Component({
  selector: 'ask-ai-action-toolbar',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['completion', 'formattedText'],
})
export class AskAiActionToolbar {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface AskAiActionToolbar extends Components.AskAiActionToolbar {}


@ProxyCmp({
})
@Component({
  selector: 'ask-ai-auth',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: [],
})
export class AskAiAuth {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface AskAiAuth extends Components.AskAiAuth {}


@ProxyCmp({
  inputs: ['completionDetails']
})
@Component({
  selector: 'ask-ai-chat-bubble-query',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['completionDetails'],
})
export class AskAiChatBubbleQuery {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface AskAiChatBubbleQuery extends Components.AskAiChatBubbleQuery {}


@ProxyCmp({
  inputs: ['completion', 'inProgress']
})
@Component({
  selector: 'ask-ai-chat-bubble-response',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['completion', 'inProgress'],
})
export class AskAiChatBubbleResponse {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface AskAiChatBubbleResponse extends Components.AskAiChatBubbleResponse {}


@ProxyCmp({
})
@Component({
  selector: 'ask-ai-chat-conversation-container',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: [],
})
export class AskAiChatConversationContainer {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface AskAiChatConversationContainer extends Components.AskAiChatConversationContainer {}


@ProxyCmp({
  inputs: ['completions']
})
@Component({
  selector: 'ask-ai-chat-group',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['completions'],
})
export class AskAiChatGroup {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface AskAiChatGroup extends Components.AskAiChatGroup {}


@ProxyCmp({
  inputs: ['activeEllipsis', 'chat']
})
@Component({
  selector: 'ask-ai-chat-history-item',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['activeEllipsis', 'chat'],
})
export class AskAiChatHistoryItem {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['EllipsisClicked']);
  }
}


export declare interface AskAiChatHistoryItem extends Components.AskAiChatHistoryItem {

  EllipsisClicked: EventEmitter<CustomEvent<number>>;
}


@ProxyCmp({
  inputs: ['disabled'],
  methods: ['stopListening']
})
@Component({
  selector: 'ask-ai-chat-speech-input',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['disabled'],
})
export class AskAiChatSpeechInput {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['speechStateChange', 'textChange', 'speechError']);
  }
}


import type { SpeechInputState as IAskAiChatSpeechInputSpeechInputState } from '@mri/ask-agora-insights';

export declare interface AskAiChatSpeechInput extends Components.AskAiChatSpeechInput {

  speechStateChange: EventEmitter<CustomEvent<IAskAiChatSpeechInputSpeechInputState>>;

  textChange: EventEmitter<CustomEvent<string>>;

  speechError: EventEmitter<CustomEvent<string>>;
}


@ProxyCmp({
})
@Component({
  selector: 'ask-ai-chat-window',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: [],
})
export class AskAiChatWindow {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface AskAiChatWindow extends Components.AskAiChatWindow {}


@ProxyCmp({
})
@Component({
  selector: 'ask-ai-chat-window-body',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: [],
})
export class AskAiChatWindowBody {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface AskAiChatWindowBody extends Components.AskAiChatWindowBody {}


@ProxyCmp({
})
@Component({
  selector: 'ask-ai-chat-window-footer',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: [],
})
export class AskAiChatWindowFooter {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface AskAiChatWindowFooter extends Components.AskAiChatWindowFooter {}


@ProxyCmp({
})
@Component({
  selector: 'ask-ai-chat-window-input',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: [],
})
export class AskAiChatWindowInput {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['notification']);
  }
}


import type { ChatInlineNotification as IAskAiChatWindowInputChatInlineNotification } from '@mri/ask-agora-insights';

export declare interface AskAiChatWindowInput extends Components.AskAiChatWindowInput {

  notification: EventEmitter<CustomEvent<IAskAiChatWindowInputChatInlineNotification>>;
}


@ProxyCmp({
  inputs: ['isDisabled']
})
@Component({
  selector: 'ask-ai-chat-window-send-button',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['isDisabled'],
})
export class AskAiChatWindowSendButton {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface AskAiChatWindowSendButton extends Components.AskAiChatWindowSendButton {}


@ProxyCmp({
  inputs: ['closeButtonClick', 'feedbackError', 'feedbackSubmit']
})
@Component({
  selector: 'ask-ai-completion-feedback-panel',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['closeButtonClick', 'feedbackError', 'feedbackSubmit'],
})
export class AskAiCompletionFeedbackPanel {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface AskAiCompletionFeedbackPanel extends Components.AskAiCompletionFeedbackPanel {}


@ProxyCmp({
})
@Component({
  selector: 'ask-ai-confirmation-modal',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: [],
})
export class AskAiConfirmationModal {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface AskAiConfirmationModal extends Components.AskAiConfirmationModal {}


@ProxyCmp({
  inputs: ['offset'],
  methods: ['ShowHidePopup']
})
@Component({
  selector: 'ask-ai-container',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['offset'],
})
export class AskAiContainer {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface AskAiContainer extends Components.AskAiContainer {}


@ProxyCmp({
  inputs: ['textToCopy']
})
@Component({
  selector: 'ask-ai-copy-button',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['textToCopy'],
})
export class AskAiCopyButton {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface AskAiCopyButton extends Components.AskAiCopyButton {}


@ProxyCmp({
  inputs: ['inputDate']
})
@Component({
  selector: 'ask-ai-date-and-time',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['inputDate'],
})
export class AskAiDateAndTime {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface AskAiDateAndTime extends Components.AskAiDateAndTime {}


@ProxyCmp({
})
@Component({
  selector: 'ask-ai-delete-icon',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: [],
})
export class AskAiDeleteIcon {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface AskAiDeleteIcon extends Components.AskAiDeleteIcon {}


@ProxyCmp({
  inputs: ['completion', 'dislikeFeedbackInProgress']
})
@Component({
  selector: 'ask-ai-dislike-button',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['completion', 'dislikeFeedbackInProgress'],
})
export class AskAiDislikeButton {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface AskAiDislikeButton extends Components.AskAiDislikeButton {}


@ProxyCmp({
})
@Component({
  selector: 'ask-ai-divider-line',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: [],
})
export class AskAiDividerLine {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface AskAiDividerLine extends Components.AskAiDividerLine {}


@ProxyCmp({
})
@Component({
  selector: 'ask-ai-download-button',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: [],
})
export class AskAiDownloadButton {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface AskAiDownloadButton extends Components.AskAiDownloadButton {}


@ProxyCmp({
  inputs: ['message']
})
@Component({
  selector: 'ask-ai-edit-query-box',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['message'],
})
export class AskAiEditQueryBox {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['cancelClick', 'saveClick']);
  }
}


export declare interface AskAiEditQueryBox extends Components.AskAiEditQueryBox {

  cancelClick: EventEmitter<CustomEvent<void>>;

  saveClick: EventEmitter<CustomEvent<string>>;
}


@ProxyCmp({
})
@Component({
  selector: 'ask-ai-edit-query-button',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: [],
})
export class AskAiEditQueryButton {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface AskAiEditQueryButton extends Components.AskAiEditQueryButton {}


@ProxyCmp({
  inputs: ['height', 'width']
})
@Component({
  selector: 'ask-ai-error-image',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['height', 'width'],
})
export class AskAiErrorImage {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface AskAiErrorImage extends Components.AskAiErrorImage {}


@ProxyCmp({
  inputs: ['errorMessage']
})
@Component({
  selector: 'ask-ai-error-response-container',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['errorMessage'],
})
export class AskAiErrorResponseContainer {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['refresh']);
  }
}


export declare interface AskAiErrorResponseContainer extends Components.AskAiErrorResponseContainer {

  refresh: EventEmitter<CustomEvent<void>>;
}


@ProxyCmp({
})
@Component({
  selector: 'ask-ai-error-splash',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: [],
})
export class AskAiErrorSplash {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface AskAiErrorSplash extends Components.AskAiErrorSplash {}


@ProxyCmp({
})
@Component({
  selector: 'ask-ai-history-item-ellipsis',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: [],
})
export class AskAiHistoryItemEllipsis {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['ellipsisClicked']);
  }
}


export declare interface AskAiHistoryItemEllipsis extends Components.AskAiHistoryItemEllipsis {

  ellipsisClicked: EventEmitter<CustomEvent<MouseEvent>>;
}


@ProxyCmp({
  inputs: ['activeEllipsis', 'group']
})
@Component({
  selector: 'ask-ai-history-items-group',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['activeEllipsis', 'group'],
})
export class AskAiHistoryItemsGroup {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['ellipsisClicked']);
  }
}


export declare interface AskAiHistoryItemsGroup extends Components.AskAiHistoryItemsGroup {

  ellipsisClicked: EventEmitter<CustomEvent<number>>;
}


@ProxyCmp({
})
@Component({
  selector: 'ask-ai-landing-splash',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: [],
})
export class AskAiLandingSplash {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface AskAiLandingSplash extends Components.AskAiLandingSplash {}


@ProxyCmp({
  inputs: ['completion', 'dislikeFeedbackInProgress', 'feedbackSubmit']
})
@Component({
  selector: 'ask-ai-like-button',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['completion', 'dislikeFeedbackInProgress', 'feedbackSubmit'],
})
export class AskAiLikeButton {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface AskAiLikeButton extends Components.AskAiLikeButton {}


@ProxyCmp({
})
@Component({
  selector: 'ask-ai-loading-animation',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: [],
})
export class AskAiLoadingAnimation {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface AskAiLoadingAnimation extends Components.AskAiLoadingAnimation {}


@ProxyCmp({
})
@Component({
  selector: 'ask-ai-loading-modal',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: [],
})
export class AskAiLoadingModal {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface AskAiLoadingModal extends Components.AskAiLoadingModal {}


@ProxyCmp({
  inputs: ['actionTitle', 'svgIcon']
})
@Component({
  selector: 'ask-ai-navigation-action-item',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['actionTitle', 'svgIcon'],
})
export class AskAiNavigationActionItem {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface AskAiNavigationActionItem extends Components.AskAiNavigationActionItem {}


@ProxyCmp({
})
@Component({
  selector: 'ask-ai-navigation-history-list',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: [],
})
export class AskAiNavigationHistoryList {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface AskAiNavigationHistoryList extends Components.AskAiNavigationHistoryList {}


@ProxyCmp({
})
@Component({
  selector: 'ask-ai-new-chat-action',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: [],
})
export class AskAiNewChatAction {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface AskAiNewChatAction extends Components.AskAiNewChatAction {}


@ProxyCmp({
})
@Component({
  selector: 'ask-ai-product-logo',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: [],
})
export class AskAiProductLogo {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface AskAiProductLogo extends Components.AskAiProductLogo {}


@ProxyCmp({
  inputs: ['suggestion']
})
@Component({
  selector: 'ask-ai-query-suggestion',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['suggestion'],
})
export class AskAiQuerySuggestion {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface AskAiQuerySuggestion extends Components.AskAiQuerySuggestion {}


@ProxyCmp({
})
@Component({
  selector: 'ask-ai-query-suggestion-container',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: [],
})
export class AskAiQuerySuggestionContainer {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface AskAiQuerySuggestionContainer extends Components.AskAiQuerySuggestionContainer {}


@ProxyCmp({
  inputs: ['groups']
})
@Component({
  selector: 'ask-ai-recent-chat-history',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['groups'],
})
export class AskAiRecentChatHistory {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface AskAiRecentChatHistory extends Components.AskAiRecentChatHistory {}


@ProxyCmp({
  inputs: ['refreshClicked']
})
@Component({
  selector: 'ask-ai-refresh-button',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['refreshClicked'],
})
export class AskAiRefreshButton {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface AskAiRefreshButton extends Components.AskAiRefreshButton {}


@ProxyCmp({
  inputs: ['fill', 'height', 'width']
})
@Component({
  selector: 'ask-ai-refresh-icon',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['fill', 'height', 'width'],
})
export class AskAiRefreshIcon {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface AskAiRefreshIcon extends Components.AskAiRefreshIcon {}


@ProxyCmp({
})
@Component({
  selector: 'ask-ai-rename-chat-modal',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: [],
})
export class AskAiRenameChatModal {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface AskAiRenameChatModal extends Components.AskAiRenameChatModal {}


@ProxyCmp({
})
@Component({
  selector: 'ask-ai-resend-query-button',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: [],
})
export class AskAiResendQueryButton {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface AskAiResendQueryButton extends Components.AskAiResendQueryButton {}


@ProxyCmp({
})
@Component({
  selector: 'ask-ai-response-avatar',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: [],
})
export class AskAiResponseAvatar {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface AskAiResponseAvatar extends Components.AskAiResponseAvatar {}


@ProxyCmp({
  inputs: ['suggestion']
})
@Component({
  selector: 'ask-ai-response-suggestion',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['suggestion'],
})
export class AskAiResponseSuggestion {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface AskAiResponseSuggestion extends Components.AskAiResponseSuggestion {}


@ProxyCmp({
})
@Component({
  selector: 'ask-ai-response-suggestion-container',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: [],
})
export class AskAiResponseSuggestionContainer {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface AskAiResponseSuggestionContainer extends Components.AskAiResponseSuggestionContainer {}


@ProxyCmp({
  inputs: ['isVisible']
})
@Component({
  selector: 'ask-ai-scroll-down-button',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['isVisible'],
})
export class AskAiScrollDownButton {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface AskAiScrollDownButton extends Components.AskAiScrollDownButton {}


@ProxyCmp({
})
@Component({
  selector: 'ask-ai-sidebar',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: [],
})
export class AskAiSidebar {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface AskAiSidebar extends Components.AskAiSidebar {}


@ProxyCmp({
})
@Component({
  selector: 'ask-ai-sidebar-nav-container',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: [],
})
export class AskAiSidebarNavContainer {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface AskAiSidebarNavContainer extends Components.AskAiSidebarNavContainer {}


@ProxyCmp({
})
@Component({
  selector: 'ask-ai-sparkle-button',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: [],
})
export class AskAiSparkleButton {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface AskAiSparkleButton extends Components.AskAiSparkleButton {}


@ProxyCmp({
})
@Component({
  selector: 'ask-ai-speak-button',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: [],
})
export class AskAiSpeakButton {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface AskAiSpeakButton extends Components.AskAiSpeakButton {}


@ProxyCmp({
})
@Component({
  selector: 'ask-ai-speech-disabled-icon',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: [],
})
export class AskAiSpeechDisabledIcon {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface AskAiSpeechDisabledIcon extends Components.AskAiSpeechDisabledIcon {}


@ProxyCmp({
  inputs: ['disabled']
})
@Component({
  selector: 'ask-ai-speech-input-icon',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['disabled'],
})
export class AskAiSpeechInputIcon {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface AskAiSpeechInputIcon extends Components.AskAiSpeechInputIcon {}


@ProxyCmp({
})
@Component({
  selector: 'ask-ai-speech-listening-icon',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: [],
})
export class AskAiSpeechListeningIcon {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface AskAiSpeechListeningIcon extends Components.AskAiSpeechListeningIcon {}


@ProxyCmp({
})
@Component({
  selector: 'ask-ai-stop-icon',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: [],
})
export class AskAiStopIcon {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface AskAiStopIcon extends Components.AskAiStopIcon {}


@ProxyCmp({
  inputs: ['hideBackground', 'notificationType']
})
@Component({
  selector: 'ask-ai-toolbar-inline-notification',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['hideBackground', 'notificationType'],
})
export class AskAiToolbarInlineNotification {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface AskAiToolbarInlineNotification extends Components.AskAiToolbarInlineNotification {}


